import { CommandBar, DetailsList, DetailsListLayoutMode, IColumn, ICommandBarItemProps, IconButton, Link, MessageBar, MessageBarType, ProgressIndicator, SelectionMode, Stack } from '@fluentui/react';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { getServerHost, isCanvasTeacher, isCurrentUserAStudentOrTeacherInCourse, saveBase64, sendApiRequest, styles } from '../lib/helper';
import { useAssignmentContext } from '../providers/assignmentsprovider';
import { useAuthenticationContext } from '../providers/authenticationprovider';
import { CourseWorkProvider, CourseWorksContext } from '../providers/courseworkprovider';
import { ICourseWorkFlat } from '../types/IAssignment';
import { IApiContext } from '../types/Shared';
import { FileUploadControl } from './FileUploadControl';

const SupplementalFolderListView: React.FunctionComponent<{ files: ICourseWorkFlat[] }> = ({ files }) => {
    const params = useParams();
    const _getColumns = (): IColumn[] => {
        return [
            {
                key: "name",
                name: "Name",
                minWidth: 300,
                maxWidth: 300,
                fieldName: "FileName",
                onRender: (item) => {
                    return <Link onClick={() => {
                        const url = `/api/blobStorage/getBlobAsBase64FromPath?path=${encodeURIComponent(item.FilePath)}`;
                        sendApiRequest(url, "GET").then(res => {
                            saveBase64(res, item.FileName)
                        });
                    }}>{item.FileName}</Link>
                }
            }
        ];
    };

    const items = [...files];
    return <Stack>
        <DetailsList
        layoutMode={DetailsListLayoutMode.justified}
        items={items}
        selectionMode={SelectionMode.none}
        columns={_getColumns()}
    />
    {items.length === 0 && <span>There are no files in the {params.supplementalFolderName} folder</span>}
    </Stack>;
    
};

const SupplementalFolder: React.FunctionComponent = () => {
    const params = useParams();
    const authContext = useAuthenticationContext();
    const assignmentContext = useAssignmentContext();
    const [isFileUploadDialogOpen, setIsFileDialogUploadOpen] = React.useState(false);

    const currentUseIsStudentOrTeacherInCourse = assignmentContext.SelectedAssignment && authContext.Result && isCanvasTeacher(authContext.Result) && isCurrentUserAStudentOrTeacherInCourse(authContext.Result!, assignmentContext.SelectedAssignment.Course);

    const _getCommandBarItems = (): ICommandBarItemProps[] => {
        return [{
            key: "upload",
            text: "Upload",
            commandBarButtonAs: () => {
                return <Stack horizontal>
                    <IconButton iconProps={{ iconName: "Upload" }}
                        onClick={() => {
                            setIsFileDialogUploadOpen(true);
                        }}
                    />
                    <Link onClick={() => {
                        setIsFileDialogUploadOpen(true);
                    }} style={{ marginTop: 6 }}>
                        Upload </Link>
                </Stack>;
            }
        }];
    };

    return <div className="coursework-wrapper">
        <h2 style={{fontWeight: "normal"}}>{params.supplementalFolderName}</h2>
        {assignmentContext.SelectedAssignment &&
            <CourseWorkProvider assignment={assignmentContext.SelectedAssignment} resetFlag={false}>
                <CourseWorksContext.Consumer>{(value: IApiContext<ICourseWorkFlat[]>) => <div>
                    {value.Pending && <ProgressIndicator />}
                    {value.Error && <MessageBar messageBarType={MessageBarType.error}>{value.Error}</MessageBar>}
                    {value.Result &&
                        <FileUploadControl allowMultiple={true}
                            shouldOpenDialog={isFileUploadDialogOpen}
                            postUrlPath={`https://${getServerHost()}/api/blobStorage/uploadCourseWorkDocument`}
                            isReadOnly={!currentUseIsStudentOrTeacherInCourse}
                            params={{ assignment: JSON.stringify(assignmentContext.SelectedAssignment), user: authContext.Result?.UserInfo?.DisplayName }}
                            onSuccess={(file) => {
                                const assignment = assignmentContext.SelectedAssignment;
                                if (assignment) {
                                    assignmentContext.SetSelectedAssignment(undefined)
                                    assignmentContext.SetSelectedAssignment(assignment)
                                }
                            }}
                        >
                            {currentUseIsStudentOrTeacherInCourse && authContext.Result && isCanvasTeacher(authContext.Result) && <CommandBar styles={{ root: styles.commandBarRoot }} items={_getCommandBarItems()} />}
                            {!value.Pending && <SupplementalFolderListView files={value.Result} />}
                        </FileUploadControl>
                    }
                </div>}</CourseWorksContext.Consumer>
            </CourseWorkProvider>
        }
    </div>;
};

export default SupplementalFolder;